(function () {
    angular.module('tradersyard').component('tyLoadMoreButton', {
        template:
            '<div class="ty-load-more">' +
            '<button class="lmb-has-more" ng-show="!$ctrl.hasReachedEnd" ng-click="$ctrl.loadMoreItems()">{{ $ctrl.labelLoadMore }}</button>' +
            '<span class="lmb-end-reached" ng-show="$ctrl.hasReachedEnd">{{ $ctrl.labelEndReached }}</span>' +
            '</div>',
        transclude: true,
        bindings: {
            onClick: '&',
            currentPage: '<',
            totalPages: '<',
            labelLoadMore: '@?',
            labelEndReached: '@?',
        },
        controller: loadMoreButtonController,
    });

    /**
     * Dumb component for loading more items from paginated resource endpoints.
     */
    function loadMoreButtonController() {
        var ctrl = this;

        ctrl.hasReachedEnd = false;

        /**
         * Called each time someone clicks the Load More button.
         * Emit event with the next page number.
         */
        ctrl.loadMoreItems = function () {
            ctrl.onClick({ page: ++ctrl.currentPage });
        };

        ctrl.$onChanges = function (changes) {
            ctrl.labelLoadMore = ctrl.labelLoadMore || 'Load more';
            ctrl.labelEndReached = ctrl.labelEndReached || 'No more items';
            ctrl.hasReachedEnd = hasReachedEnd();
        };

        function hasReachedEnd() {
            return ctrl.totalPages !== undefined && ctrl.currentPage >= ctrl.totalPages;
        }
    }
})();
